RFM_APP.controller("requestMilesSummaryController", ["$scope", "$state", "$timeout", "requestMilesService", "helper", function ($scope, $state, $timeout, requestMilesService, helper) {
    helper.updatePageTitle("pageTitle_summary_rfm");
    var summary = requestMilesService.getSummary();
    if(summary == null){
        $state.go('request'); 
    }    
    $scope.confirmFlights = summary.response;
    $scope.form = summary.payLoad;
    delete $scope.form["errors"];
    delete $scope.form["errorKeys"];
    $scope.backToManual = function(){
        delete $scope.form["errors"];
        $state.go('long');
    }

    function formatPhoneNumber(countryCode, phoneNumber) {
        if(countryCode == 1) {
        var s2 = (""+phoneNumber).replace(/\D/g, '');
        var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        var formatedPhone = (!m) ? null : "+1 (" + m[1] + ") " + m[2] + "-" + m[3];
        return formatedPhone;
        } else {
            return ("+" + countryCode + " " + phoneNumber);
        }
    }
    $scope.formatPhoneNumber = formatPhoneNumber;
    
    function chunk(arr, size) {
        var newArr = [];
        for (var i=0; i<arr.length; i+=size) {
          newArr.push(arr.slice(i, i+size));
        }
        return newArr;
    }
    $scope.chunkedFlightData = chunk($scope.confirmFlights, 3);
    $scope.confirmSubmit = function(){
        requestMilesService.submitSummary($scope.form).then(
            function(response){
                if(typeof response.data.errorSummaryMessage !== 'undefined'){
                    $scope.form.errors = response.data;
                    $timeout(function() {
                        helper.scrollToErrorSummary($j("#errorSummary"));
                    }, 0);
                    requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Summary");
                    requestMilesService.addToWebAnalytics("error_id", requestMilesService.getPageErrorCodes());
                    requestMilesService.reportToWebAnalytics();
                }else{
                    requestMilesService.clearPageErrorCodes();
                    $state.go('request-submitted');
                }
            },function(error){
                helper.errorHandler(error, $errorMessage, errorPage);                
            });
    }
    requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Summary");
    requestMilesService.overrideSkipLinks();
    $j("html,body").scrollTop(0);
}]);
